import styled, { keyframes } from "styled-components";
import { styled as muiStyled } from "@mui/material/styles";
import { Button, Divider, Typography, Alert } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";

const slideInFromRight = keyframes`
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 25px;
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  background-color: ${({ theme }) => theme.palette.background.paper};
`;

export const ContainerTabsNavigation = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.palette.background.paper};
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
`;

export const TabContentContainer = styled.div`
  display: flex;
  width: 100%;
  overflow-x: hidden;
`;

export const TabContent = styled.div<{
  isActive: boolean;
  animationDirection: "left" | "right" | "none";
  isAnimating: boolean;
}>`
  display: ${(props) => (props.isActive ? "block" : "none")};
  width: ${(props) => (props.isActive ? "100%" : "0")};
  animation: ${(props) => {
      if (!props.isActive || !props.isAnimating) return "none";
      return slideInFromRight;
    }}
    0.3s ease-in-out;
  transition: ${(props) =>
    props.isAnimating ? "none" : "all 0.3s ease-in-out"};
  pointer-events: ${(props) => (props.isActive ? "auto" : "none")};
  z-index: ${(props) => (props.isActive ? 1 : 0)};
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 10px;
`;

export const ImportantNotice = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  border-radius: 4px;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const DividerStyled = muiStyled(Divider)({
  margin: "20px 0",
});

export const DeleteButton = muiStyled(Button)({
  backgroundColor: "#9847F5",
  color: "#FFFFFF",
  borderRadius: "40px",
  padding: "8px 22px",
  textTransform: "uppercase",
  fontSize: "15px",
  fontWeight: 500,
  letterSpacing: "0.46px",
  boxShadow:
    "0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.2)",
  "&:hover": {
    backgroundColor: "#7a3ac4",
    boxShadow:
      "0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.2)",
  },
  "&:disabled": {
    backgroundColor: "rgba(0, 0, 0, 0.12)",
    color: "rgba(0, 0, 0, 0.26)",
  },
});

export const EditButton = muiStyled(Button)({
  borderRadius: "999px",
});

export const CancelButton = muiStyled(Button)({
  width: 120,
  height: 36,
  borderRadius: "40px",
  borderColor: "rgba(0, 0, 0, 0.5)",
  color: "#000000",
  textTransform: "uppercase",
  fontSize: "14px",
  fontWeight: 500,
  "&:hover": {
    background: "transparent",
    borderColor: "rgba(0, 0, 0, 0.5)",
  },
});

export const PrimaryButton = muiStyled(Button)({
  borderRadius: "999px",
});

export const InfoIconStyled = muiStyled(InfoOutlined)(({ theme }) => ({
  fontSize: 20,
  color: theme.palette.text.primary,
}));

export const InfoTypography = muiStyled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: "14px",
}));

export const ImportantLabel = muiStyled("span")({
  fontWeight: 500,
});

export const AlertStyled = muiStyled(Alert)({
  width: "100%",
});

export const ModalTypography = muiStyled(Typography)({
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "32px",
  letterSpacing: "0.15px",
  color: "rgba(0, 0, 0, 0.87)",
});

export const ModalInfoIcon = muiStyled(InfoOutlined)({
  fontSize: 20,
  color: "#1C1B1F",
  flexShrink: 0,
  marginTop: "2px",
});

export const ModalImportantText = muiStyled(Typography)({
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.17px",
  color: "rgba(0, 0, 0, 0.87)",
}) as typeof Typography;

export const ModalImportantTextBold = muiStyled(Typography)({
  fontSize: "14px",
  fontWeight: 600,
  lineHeight: "20px",
  letterSpacing: "0.17px",
  color: "rgba(0, 0, 0, 0.87)",
}) as typeof Typography;
